import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SocialProofBar = () => {
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/founding-spots`);
        setRemaining(res.data.remaining);
      } catch { setRemaining(27); }
    };
    fetch();
    const iv = setInterval(fetch, 30000);
    return () => clearInterval(iv);
  }, []);

  if (remaining === null) return null;
  const soldOut = remaining <= 0;

  return (
    <motion.div data-testid="social-proof-bar"
      className="sticky top-0 z-50 w-full backdrop-blur-xl bg-indigo-700/90 border-b border-gold/20"
      initial={{ y: -60 }} animate={{ y: 0 }} transition={{ delay: 0.5, duration: 0.5 }}>
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center justify-center gap-3">
        <AlertTriangle className="w-4 h-4 text-gold" />
        <p className="text-sm font-inter font-medium text-white tracking-wide">
          {soldOut ? (
            <>Founding 50 is <span className="text-red-400 font-bold">FULL</span> — Join the General Waitlist</>
          ) : (
            <>
              <span className="font-bold">Limited Availability:</span> Accepting only{" "}
              <span className="text-gold font-bold" data-testid="spots-remaining-count">{remaining}</span>
              {" "}more Founding Partners for Phase 1
            </>
          )}
        </p>
        {!soldOut && <span className="inline-block w-2 h-2 rounded-full bg-lime animate-pulse" />}
      </div>
    </motion.div>
  );
};
